import { ChevronRightIcon, HomeIcon } from '@heroicons/react/outline'
import { useRouter } from 'next/router'

import Link from '@/components/link'
import DashboardLinks from '@/config/dashboard-links'

const Navigation = () => {
  const { pathname } = useRouter()
  const page = DashboardLinks.find((link) => pathname.startsWith(link.route))

  return !page || page.route === '/dashboard/overview' ? null : (
    <nav className='mx-auto -mt-6 flex w-full' aria-label='Breadcrumb'>
      <ol className='flex items-center space-x-2'>
        <li>
          <div>
            <Link
              href='/dashboard'
              className='text-gray-400 hover:text-gray-500'
            >
              <HomeIcon className='h-5 w-5 flex-shrink-0' aria-hidden='true' />
              <span className='sr-only'>Home</span>
            </Link>
          </div>
        </li>
        <li>
          <div className='flex items-center'>
            <ChevronRightIcon className='h-5 w-5 flex-shrink-0 text-gray-400' />
            <Link
              href={page.route}
              className={`${
                page.current ? 'pointer-events-none' : ''
              } ml-2 mt-0.5 text-sm font-medium text-[#ffa356] hover:text-[#ffa356] sm:text-xl`}
            >
              {page.name}
            </Link>
          </div>
        </li>
      </ol>
    </nav>
  )
}

export default Navigation
